export default "__VITE_ASSET__BtJnqPTG__"